enum CeErrorCode {
  EngagementDateOutOfRange = 'ce_engagement_date_out_of_range',
  EntryMonthChanged = 'ce_entry_month_changed',
  ExemptionOverlap = 'ce_exemption_overlap',
}

export default CeErrorCode;
